import woltInstance from '../instance'

const fetchWoltDriverIntegrations = (page, size) => {
  return woltInstance.get('/driverIntegrations?page=' +  page +'&size=' + size)
}

export default fetchWoltDriverIntegrations
